import { render, staticRenderFns } from "./custom-label-input.vue?vue&type=template&id=038030e4"
import script from "./custom-label-input.vue?vue&type=script&lang=js"
export * from "./custom-label-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports